import React, { FC } from "react";
import ReactSelect, { GroupBase, Props as SelectProps } from "react-select";
import { ISelectOption } from "src/@types/form";
import { SELECT_CUSTOM_COMPONENTS, SELECT_CUSTOM_STYLES } from "./constants";

interface Props
  extends SelectProps<ISelectOption, boolean, GroupBase<ISelectOption>> {}

export const Select: FC<Props> = (props) => (
  <ReactSelect
    styles={SELECT_CUSTOM_STYLES}
    components={SELECT_CUSTOM_COMPONENTS}
    isSearchable={true}
    isClearable={false}
    captureMenuScroll={false}
    {...props}
    placeholder=""
  />
);
